/**
 * HTL (18-07-23)
 * If user's localstorage doesn't have the consented flag, show the banner
 */
type ShowCookieConsentType = {
  itemToGet: string;
};
export function ShowCookieConsent(props: ShowCookieConsentType) {
  /**
   * HTL (18-07-23)
   * Fetch item from localstorage
   */
  let cookieConsentGranted: string | null = localStorage.getItem(props.itemToGet);
  if (cookieConsentGranted === null) {
    return true;
  }
  if (cookieConsentGranted) return false;
  return true;
}
